import type { Locale } from '../content/types'

const NBSP = ' '

/**
 * `1191` → `1 191` (it) / `1,191` (en), the grouping the dictionaries use in
 * prose. A regex, not `toLocaleString`: the prerender's ICU and a browser's
 * may disagree, and prerendered numbers must hydrate identical. Used by the
 * zone table and the manifesto's valley profile.
 */
export function grouped(n: number, locale: Locale): string {
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, locale === 'en' ? ',' : NBSP)
}
